import script from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\layout\\KTopo\\KTopoDesktop.vue?type=script"
export * from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\layout\\KTopo\\KTopoDesktop.vue?type=script"
export default script